module.exports = __webpack_public_path__ + "static/2-d3f47f508ef606a0490859ce10fb641c.jpg";